<template>
  <div class="share-container">
    <span class="text">поделиться:</span>
    <social-sharing
      :url="url"
      title="ХАЙКНИ СВОЙ ОТПУСК вместе с Japan Airlines и «Рамблером»!"
      v-cloak
      inline-template
    >
      <ul>
        <li @click="$ga.event('Шаринг', 'Шаринг facebook', 'Шаринг facebook')">
          <network network="facebook" id="facebook">
            <i class="icon icon-facebook"></i>
          </network>
        </li>

        <li
          @click="$ga.event('Шаринг', 'Шаринг вконтакте', 'Шаринг вконтакте')"
        >
          <network network="vk" id="vk">
            <i class="icon icon-vkontakte"></i>
          </network>
        </li>
        <li
          @click="
            $ga.event(
              'Шаринг',
              'Шаринг однокклассники',
              'Шаринг однокклассники'
            )
          "
        >
          <network network="odnoklassniki">
            <i class="icon icon-ok"></i>
          </network>
        </li>
        <li @click="$ga.event('Шаринг', 'Шаринг телеграм', 'Шаринг телеграм')">
          <network network="telegram">
            <i class="icon icon-telegram"></i>
          </network>
        </li>
        <li @click="$ga.event('Шаринг', 'Шаринг twitter', 'Шаринг twitter')">
          <network network="twitter" id="twitter">
            <i class="icon icon-twitter"></i>
          </network>
        </li>
      </ul>
    </social-sharing>
  </div>
</template>

<script>
export default {
  name: "ShareBlock",
  props: ["title"],
  computed: {
    url() {
      const url =
        window.location != window.parent.location
          ? document.referrer
          : document.location.href;

      return url
        ? `http://jal.rambler.ru/share/?redirect=${encodeURIComponent(url)}`
        : `http://jal.rambler.ru/share/`;
    }
  }
};
</script>

<style lang="scss">
.share-container {
  display: flex;
  justify-content: space-between;

  .text {
    padding-left: 40px;
    font-size: 16px; /* Приближение из-за подстановки шрифтов */
    font-weight: 500;
    line-height: 40px; /* Приближение из-за подстановки шрифтов */
    text-align: left;
    text-transform: uppercase;
  }

  .icon {
    display: block;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    transition: all ease-in-out 100ms;
    box-sizing: border-box;
    &:hover {
      transform: scale(1.2);
    }

    &.icon-telegram {
      width: 14px;
      height: 13px;
      background-image: url("../assets/share/tg.png");
    }
    &.icon-twitter {
      width: 15px;
      height: 13px;
      background-image: url("../assets/share/tw.png");
    }
    &.icon-vkontakte {
      width: 18px;
      height: 11px;
      background-image: url("../assets/share/vk.png");
    }
    &.icon-facebook {
      width: 7px;
      height: 15px;
      background-image: url("../assets/share/fb.png");
    }
    &.icon-ok {
      width: 12px;
      height: 19px;
      background-image: url("../assets/share/ok.png");
    }

    &:hover {
      cursor: pointer;
    }
  }

  ul {
    display: flex;
    justify-content: space-evenly;
    width: 130px;
    list-style: none;
    align-items: center;
    margin: 0;
    padding: 0;
  }
}

@media screen and (max-width: 669px) {
  .share-container {
    flex-direction: column;

    .text {
      padding-left: 0;
      font-size: 11px;
      line-height: 25px;
    }
    ul {
      justify-content: space-between;
    }
  }
}
</style>
